import { render, staticRenderFns } from "./unionInfoManage.vue?vue&type=template&id=78b87284&scoped=true&"
import script from "./unionInfoManage.vue?vue&type=script&lang=js&"
export * from "./unionInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./unionInfoManage.vue?vue&type=style&index=0&id=78b87284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b87284",
  null
  
)

component.options.__file = "unionInfoManage.vue"
export default component.exports